import React from "react";
import PropTypes from "prop-types";
import { Breadcrumb } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { FormattedMessage } from "react-intl";
import { getLinkElement } from "./AlmigLink";
import "./Breadcrumb.css";

const genChildren = (location, compressors) => {
	let children = [];
	const parts = location.pathname.split("/");
	let abspath = "";
	for (let i = 0; i < parts.length; i++) {
		let is_last = i === parts.length - 1;
		if (abspath.length === 1) {
			abspath += parts[i];
		} else {
			abspath += "/" + parts[i];
		}
		let content = getLinkElement(abspath, compressors);
		children.push(!is_last
			? <LinkContainer key={i} to={abspath}>
				<Breadcrumb.Item>
					{ content }
				</Breadcrumb.Item>
			</LinkContainer>
			: <Breadcrumb.Item key={i} active>
				{ content }
			</Breadcrumb.Item>);
	}
	return children;
};

const AlmigBreadcrumb = (props) => (
	<div className="Breadcrumb">
		<FormattedMessage id="You are here:" className="Breadcrumb-Text"/>
		<Breadcrumb>
			{ genChildren(props.location, props.compressors) }
		</Breadcrumb>
	</div>
);

AlmigBreadcrumb.propTypes = {
	location: PropTypes.object.isRequired,
	compressors: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default AlmigBreadcrumb;
